import { Component, EventEmitter, HostBinding, Input, OnInit, Output } from '@angular/core';
import { animate, animateChild, query, style, transition, trigger } from '@angular/animations';
import { ISnackItem } from '@shared/interfaces/various/ISnackItem';
import { SnackType } from '@shared/enums';

@Component({
    selector: 'app-snacks-item',
    templateUrl: './snacks-item.component.html',
    styleUrls: ['./snacks-item.component.scss'],
    animations: [
        trigger('itemCreated', [
            transition('void -> *', [
                query('.snack-item', [
                    style({ opacity: 1, transform: 'translateX(100%)' }),
                    animate('300ms cubic-bezier(0.35, 0, 0.25, 1)', style({ opacity: 1, transform: 'none' }))
                ])
            ]),
            transition('* -> void', [
                query('.snack-item', [
                    style({ opacity: 1, transform: 'translateY(0)' }),
                    animate(
                        '100ms cubic-bezier(0.35, 0, 0.25, 1)',
                        style({
                            opacity: 1,
                            transform: 'translateY(-100%)'
                        })
                    ),
                    animateChild()
                ])
            ])
        ]),
        trigger('comeUp', [
            transition(':decrement, :increment', [
                query('.snack-item', [
                    style({ opacity: 1, transform: 'translateY(0)' }),
                    animate(
                        '100ms cubic-bezier(0.35, 0, 0.25, 1)',
                        style({
                            opacity: 1,
                            transform: 'translateY(-{{percentage}}%)'
                        })
                    )
                ])
            ])
        ])
    ],
    standalone: false
})
export class SnacksItemComponent implements OnInit {
    @HostBinding('@itemCreated') itemCreated;
    @Output() closeItem = new EventEmitter();
    @Input() zIndex: number;
    @Input() data: ISnackItem;
    class: { [key: string]: boolean } = {};
    private timeout: NodeJS.Timeout;

    private _index: number = null;

    get index(): number {
        return this._index;
    }

    @Input() set index(value: number) {
        const toIndex = this._index - value;
        this.comeUp = { value, params: { percentage: toIndex * 100 } };
        this._index = value;
    }

    private _comeUp: { value: any; params?: { [key: string]: any } };

    @HostBinding('@comeUp') get comeUp() {
        return this._comeUp;
    }

    set comeUp(val) {
        this._comeUp = val;
    }

    get isProgressBar(): boolean {
        return this.data?.type === SnackType.ProgressBar;
    }

    ngOnInit(): void {
        if (this.data?.duration) {
            this.timeout = setTimeout(() => this.closeNotification(), this.data.duration);
        }

        this.class.error = this.data?.type === SnackType.Error;
        this.class.success = this.data?.type === SnackType.Success;
        this.class.progress = this.data?.type === SnackType.ProgressBar;
        this.class['has-action'] = !!this.data?.action;
    }

    closeNotification() {
        this.closeItem.emit();
        this.timeout = null;
    }

    clickAction() {
        setTimeout(() => this.closeNotification(), 3000);
        this.data?.action.func();
    }
}
